<template>
  <div>
    <h2 class="ViewHeading">Risk Assessments</h2>
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-row>
        <b-col>
          <b-card-group deck
            ><b-card
              border-variant="info"
              header="Risk Assessments for Review"
              header-bg-variant="info"
              align="center"
            >
              <b-card-text
                >You have {{ ValidCounts }} Risk Assessment(s) to be
                reviewed</b-card-text
              >
              <b-card-text></b-card-text> </b-card
            ><b-card
              border-variant="warning"
              header=" Due Risk Assessments"
              header-bg-variant="warning"
              align="center"
            >
              <b-card-text
                >You have {{ DueCounts }} Risk Assessment(s) that are due within
                the next 28 days</b-card-text
              >
            </b-card>
            <b-card
              border-variant="danger"
              header=" Expired Risk Assessments "
              header-bg-variant="danger"
              align="center"
            >
              <b-card-text
                >You have {{ ExpiredCounts }} Risk Assessment(s) that is overdue
                and expired</b-card-text
              >
              <b-card-text></b-card-text>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row><br /></b-row>
    </div>
    <div>
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Risk Assessment Status" active>
            <div id="Table">
              <br />

              <h4>Risk Assessment Status</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="RiskAssessItems"
                  :fields="RiskAssessmentFields"
                  hover
                  small
                >
                  <template v-slot:cell(RAStatus)="{ item }">
                    <div v-if="item.RAStatus === 'For Review'">
                      <b-badge variant="info">For Review</b-badge>
                    </div>
                    <div v-if="item.RAStatus === 'Expired'">
                      <b-badge variant="danger">Expired</b-badge>
                    </div>
                    <div v-if="item.RAStatus === 'Due'">
                      <b-badge variant="warning">Due</b-badge>
                    </div>
                    <div v-if="item.RAStatus === 'In Progress'">
                      <b-badge variant="light">In Progress</b-badge>
                    </div>
                    <div v-if="item.RAStatus === 'Verify'">
                      <b-badge variant="secondary">Verification</b-badge>
                    </div>
                  </template>
                  <template v-slot:cell(Details)="{ item }">
                    <b-button
                      v-if="
                        item.RAStatus === 'For Review' ||
                          item.RAStatus === 'Expired' ||
                          item.RAStatus === 'Due'
                      "
                      variant="outline-info"
                      v-on:click="showRiskAssessmentNotes(item, 'current')"
                      size="sm"
                      >Show</b-button
                    >
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>
          <b-tab title=" Risk Assessment Schedule" lazy>
            <div id="Table">
              <br />

              <h4>Scheduled Risk Assessments</h4>
              <br />
              <div>
                <b-table
                  sticky-header
                  no-border-collapse
                  responsive
                  :items="ScheduledRiskAssessments"
                  :fields="ScheduledRiskAssessmentsFields"
                  hover
                  small
                  empty-text="No Scheduled Risk Assessments for this location"
                >
                  <template v-slot:cell(9)="{ item }">
                    <b-button
                      v-if="
                        item[12] == 'FALSE' ||
                          item[12] == '' ||
                          item[12] == null
                      "
                      size="sm"
                      variant="outline-info"
                      v-on:click="modifyRiskAssessmentBooking(item)"
                      >Modify</b-button
                    >
                    <b-badge v-if="item[12] == 'TRUE'">Under Edit</b-badge>
                  </template>
                </b-table>
                <b-row>
                  <b-col class="text-left">
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      v-on:click="ShowNewBooking()"
                      ><BIconPlus></BIconPlus>
                      Schedule New Assessment
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-tab>
          <b-tab lazy title="Completed">
            <br />

            <h4 class="centered">Completed Assessments</h4>
            <br />
            <b-table
              sticky-header
              no-border-collapse
              responsive
              :items="CompletedRiskAssessItems"
              :fields="CompletedRiskAssessmentsFields"
              small
              show-empty
              empty-text="You don't curently have any results to show"
            >
              <template v-slot:cell(Details)="{ item }">
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="showRiskAssessmentNotes(item, 'completed')"
                >
                  Details
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-card>
      <section
        class="noshow"
        v-if="(this.doPDF == true) & (this.modalShowing == true)"
      >
        <PDF v-if="this.doPDF == true" :key="componentKey"> </PDF>
      </section>
      <b-modal
        ref="RiskAssessmentModal"
        id="RiskAssessmentModal"
        title="Risk Assessment Notes"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
      >
        <b-card>
          <h3>{{ PassItem.RAType }}</h3>
          <b-card :header-bg-variant="statusColour">
            <template #header>
              Status: {{ PassItem.RAStatus }} - {{ PassItem.RAExpiry }}
            </template>
            <b-row>
              <b-col class="text-center"
                ><h4>{{ PassItem.RAID }}</h4></b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                ><p>
                  <b>{{ PassItem.RADesc }}</b>
                </p></b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Location: {{ PassItem.RAArea }}
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-center">Room: {{ PassItem.RARoom }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Assessor: {{ PassItem.RAAssessor }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Date Performed: {{ PassItem.RADate }}</b-col
              >
            </b-row>
            <b-row
              ><b-col><br /></b-col
            ></b-row>
          </b-card>
          <br />
          <b-card>
            <b-tabs>
              <b-tab title="Risks"
                ><b-card>
                  <template #header>
                    <h5>Risks</h5>
                  </template>
                  <div v-if="this.RiskRisks.length > 0">
                    <b-table
                      sticky-header
                      no-border-collapse
                      responsive
                      :items="this.RiskRisks"
                      :fields="this.RiskFields"
                      hover
                      small
                    >
                    </b-table>
                  </div>
                  <div v-if="this.RiskRisks.length == 0">
                    <p>There are no risks listed for this Risk Assessment</p>
                  </div>
                </b-card></b-tab
              >
              <b-tab title="Findings"
                ><b-card>
                  <template #header>
                    <h5>Findings</h5>
                  </template>
                  <b-card-text>
                    <div v-if="this.RiskFindings != ''">
                      {{ this.RiskFindings }}
                    </div>
                    <div v-if="this.RiskFindings == null">
                      <p>
                        There are no findings listed for this Risk Assessment
                      </p>
                    </div>
                  </b-card-text>
                </b-card></b-tab
              >
              <b-tab title="Guidance"
                ><b-card>
                  <template #header>
                    <h5>Recommendations</h5>
                  </template>
                  <b-card-text>
                    <div v-if="this.RiskRecommendations != ''">
                      {{ this.RiskRecommendations }}
                    </div>
                    <div v-if="this.RiskRecommendations == null">
                      <p>
                        There are no recommendations listed for this Risk
                        Assessment
                      </p>
                    </div>
                  </b-card-text>
                </b-card></b-tab
              >
              <b-tab title="Actions">
                <b-card>
                  <template #header>
                    <h5>Actions</h5>
                  </template>
                  <div v-if="this.RiskActions.length > 0">
                    <b-table
                      :items="this.RiskActions"
                      :fields="this.RiskActionFields"
                      sticky-header
                      no-border-collapse
                      responsive
                      hover
                      small
                    >
                      <template #cell(View)="row">
                        <BIconCaretDownFill
                          @click="row.toggleDetails"
                          variant="info"
                        ></BIconCaretDownFill>
                      </template>

                      <template #row-details="row">
                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"
                            ><b>Responsibility:</b></b-col
                          >
                          <b-col class="text-left" cols="6">{{
                            row.item[4]
                          }}</b-col>
                        </b-row>
                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"
                            ><b>Description:</b></b-col
                          >
                          <b-col class="text-left" cols="6">{{
                            row.item[2]
                          }}</b-col>
                        </b-row>

                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"><b>Note:</b></b-col>
                          <b-col class="text-left" cols="6">{{
                            row.item[5]
                          }}</b-col>
                        </b-row>
                      </template>
                    </b-table>
                  </div>
                  <div v-if="this.RiskActions.length == 0">
                    <p>There are no actions listed for this Risk Assessment</p>
                  </div>
                </b-card>
              </b-tab>
            </b-tabs>
          </b-card>
          <br />
          <template #footer>
            <b-card>
              <b-row>
                <b-col>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    v-on:click="DownloadAssessment(PassItem.RAID, RiskCategory)"
                  >
                    <BIconDownload></BIconDownload> Download Risk
                    Assessment</b-button
                  ></b-col
                >
              </b-row>
              <br />
              <b-col>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  v-on:click="MarkAsReviewed(PassItem.RAID)"
                  v-if="PassItem.RAStatus == 'For Review'"
                  >Mark as Reviewed</b-button
                >
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  v-on:click="RequestRA(PassItem.RAID)"
                  v-if="
                    PassItem.RAStatus == 'Due' || PassItem.RAStatus == 'Expired'
                  "
                >
                  Request New
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  v-on:click="ClearOverdue(PassItem.RAID)"
                  v-if="
                    PassItem.RAStatus == 'Due' || PassItem.RAStatus == 'Expired'
                  "
                >
                  Acknowledge and Clear
                </b-button>
              </b-col>
            </b-card>
          </template>
        </b-card>
      </b-modal>
      <b-modal
        ref="ModifyRiskBookingModal"
        id="ModifyRiskBookingModal"
        title="Risk Assessment Booking"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <b-card>
          <b-row
            ><b-col class="text-left">Assessment ID</b-col>
            <b-col> {{ ModifiedBooking.ServiceID }}</b-col></b-row
          >
          <b-row
            ><b-col class="text-left">Assessment Location</b-col>
            <b-col>
              <input type="text" v-model="ModifiedBooking.Area" required />
            </b-col>
          </b-row>
          <b-row
            ><b-col class="text-left">Assessment Room</b-col>
            <b-col
              ><input type="text" v-model="ModifiedBooking.Room" required />
            </b-col>
          </b-row>
          <!-- <b-row
            ><b-col class="text-left">Assessment Description</b-col>
            <b-col
              ><input
                type="text"
                v-model="ModifiedBooking.Description"
                required
              />
            </b-col>
          </b-row> -->
          <b-row
            ><b-col class="text-left">Arranged By</b-col>
            <b-col> {{ ModifiedBooking.ArrangedBy }} </b-col>
          </b-row>
          <br />
          Assessment Type
          <b-row>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="ModifiedBooking.Type"
                :options="riskassessments"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-select
                :options="AssType"
                v-model="ModifiedBooking.CheckType"
              >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              >Scheduled Date:
              <b-form-datepicker
                v-model="ModifiedBooking.Date"
                locale="en"
                :placeholder="ModifiedBooking.Date"
              ></b-form-datepicker
            ></b-col>
          </b-row>
          <b-row>
            <b-col
              >Scheduled Time:
              <b-form-timepicker
                v-model="ModifiedBooking.Time"
                locale="en"
                :placeholder="ModifiedBooking.Time"
              ></b-form-timepicker
            ></b-col>
          </b-row>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
          <b-row>
            <b-col
              ><b-button
                variant="outline-info"
                v-on:click="SubmitModifiedBooking()"
                >Submit Changes</b-button
              ></b-col
            >
            <b-col
              ><b-button
                variant="outline-info"
                v-on:click="CancelModifiedBooking()"
                >Cancel Changes</b-button
              ></b-col
            >
          </b-row>
          <b-row
            ><b-col><br /></b-col
          ></b-row>
        </b-card>
      </b-modal>
      <b-modal
        ref="CompletedRiskAssessmentModal"
        id="CompletedRiskAssessmentModal"
        title=" Completed Risk Assessment Notes"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        v-model="modalShowing"
      >
        <b-card>
          <h3>{{ PassItem.RAType }}</h3>
          <b-card :header-bg-variant="statusColour">
            <template #header> Status: {{ PassItem.RAStatus }} </template>
            <b-row>
              <b-col class="text-center"
                ><h4>{{ PassItem.RAID }}</h4></b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                ><p>
                  <b>{{ PassItem.RADesc }}</b>
                </p></b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Location: {{ PassItem.RAArea }}
              </b-col>
              <b-col class="text-center">Room: {{ PassItem.RARoom }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Assessor: {{ PassItem.RAAssessor }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="text-center"
                >Scheduled Date: {{ PassItem.RADate }}</b-col
              >
            </b-row>
            <b-row>
              <b-col
                >Completed On: {{ PassItem.RACompDate }} At
                {{ PassItem.RACompTime }}
              </b-col>
            </b-row>
            <b-row
              ><b-col><br /></b-col
            ></b-row>
          </b-card>
          <br />
          <b-card>
            <b-tabs>
              <b-tab title="Risks"
                ><b-card>
                  <template #header>
                    <h5>Risks</h5>
                  </template>
                  <div v-if="this.RiskRisks.length > 0">
                    <b-table
                      sticky-header
                      no-border-collapse
                      responsive
                      :items="this.RiskRisks"
                      :fields="this.RiskFields"
                      hover
                      small
                    >
                    </b-table>
                  </div>
                  <div v-if="this.RiskRisks.length == 0">
                    <p>There are no risks listed for this Risk Assessment</p>
                  </div>
                </b-card></b-tab
              >
              <b-tab title="Findings"
                ><b-card>
                  <template #header>
                    <h5>Findings</h5>
                  </template>
                  <b-card-text>
                    <div v-if="this.RiskFindings != ''">
                      {{ this.RiskFindings }}
                    </div>
                    <div v-if="this.RiskFindings == null">
                      <p>
                        There are no findings listed for this Risk Assessment
                      </p>
                    </div>
                  </b-card-text>
                </b-card></b-tab
              >
              <b-tab title="Guidance"
                ><b-card>
                  <template #header>
                    <h5>Recommendations</h5>
                  </template>
                  <b-card-text>
                    <div v-if="this.RiskRecommendations != ''">
                      {{ this.RiskRecommendations }}
                    </div>
                    <div v-if="this.RiskRecommendations == null">
                      <p>
                        There are no recommendations listed for this Risk
                        Assessment
                      </p>
                    </div>
                  </b-card-text>
                </b-card></b-tab
              >
              <b-tab title="Actions">
                <b-card>
                  <template #header>
                    <h5>Actions</h5>
                  </template>
                  <div v-if="this.RiskActions.length > 0">
                    <b-table
                      :items="this.RiskActions"
                      :fields="this.RiskActionFields"
                      sticky-header
                      no-border-collapse
                      responsive
                      hover
                      small
                    >
                      <template #cell(View)="row">
                        <BIconCaretDownFill
                          @click="row.toggleDetails"
                          variant="info"
                        ></BIconCaretDownFill>
                      </template>

                      <template #row-details="row">
                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"
                            ><b>Responsibility:</b></b-col
                          >
                          <b-col class="text-left" cols="6">{{
                            row.item[4]
                          }}</b-col>
                        </b-row>
                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"
                            ><b>Description:</b></b-col
                          >
                          <b-col class="text-left" cols="6">{{
                            row.item[2]
                          }}</b-col>
                        </b-row>

                        <b-row no-gutters>
                          <b-col cols="6" class="text-left"><b>Note:</b></b-col>
                          <b-col class="text-left" cols="6">{{
                            row.item[5]
                          }}</b-col>
                        </b-row>
                      </template>
                    </b-table>
                  </div>
                  <div v-if="this.RiskActions.length == 0">
                    <p>There are no actions listed for this Risk Assessment</p>
                  </div>
                </b-card>
              </b-tab>
            </b-tabs>
          </b-card>

          <template #footer>
            <b-card>
              <b-row>
                <b-col>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    v-on:click="DownloadAssessment(PassItem.RAID, RiskCategory)"
                  >
                    <BIconDownload></BIconDownload> Download Risk
                    Assessment</b-button
                  ></b-col
                >
              </b-row>
            </b-card>
          </template>
        </b-card>
      </b-modal>
      <b-modal
        ref="NewBookingModal"
        id="NewBookingModal"
        title="New Risk Assessment Booking"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <b-card
          header-bg-variant="dark"
          border-variant="light"
          bg-variant="light"
        >
          <template #header>
            <h6 class="orderHeader">New Risk Assessment Request Form</h6>
          </template>
          <template #footer>
            <b-col class="centered">
              <b-button
                v-on:click="SubmitRABooking(DormantID)"
                variant="outline-info"
                small
                >Submit</b-button
              >
              <b-button
                v-on:click="ResetRABooking()"
                variant="outline-info"
                small
                >Cancel</b-button
              >
            </b-col>
          </template>
          <h5 class="accessoriesHeader">Assessment Type</h5>
          <b-row>
            <b-col>
              <b-form-select
                id="input-3"
                v-model="newBooking.Type"
                :options="riskassessments"
                required
              ></b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-select :options="AssType" v-model="newBooking.CheckType">
              </b-form-select>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col v-if="newBooking.CheckType == 'Single Outlet'">
              <b-form-input
                id="OutletID"
                v-model="newBooking.OutletID"
                placeholder="OutletID"
                required
              ></b-form-input>
            </b-col>
            <b-col>
              <b-form-input
                id="Area"
                v-model="newBooking.Room"
                placeholder="Room/Area"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-input
                id="LocationNote"
                v-model="newBooking.Note"
                placeholder="Location Note"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <hr />
          <b-row
            ><b-col>
              <h5 class="accessoriesHeader">Date</h5>

              <b-form-datepicker
                id="input-4"
                v-model="newBooking.Date"
                class="mb-2"
              ></b-form-datepicker>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5 class="accessoriesHeader">Time</h5>

              <b-form-timepicker
                locale="en"
                v-model="newBooking.Time"
              ></b-form-timepicker>
            </b-col>
          </b-row>
          <hr />
          <h5 class="accessoriesHeader">Contact Information</h5>
          <b-row>
            <b-col>
              <b-form-input
                id="input-2"
                v-model="newBooking.Name"
                placeholder="Enter name"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-input
                placeholder="Email Address"
                v-model="newBooking.Email"
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-input
                id="input-2"
                v-model="newBooking.ContactNote"
                placeholder="Note for Contact"
                required
                max="150"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-modal>
      <b-modal
        ref="ClearRiskAssessmentModal"
        id="ClearRiskAssessmentModal"
        title="Clear Risk Assessment Notification"
        content-class="Modal"
        header-bg-variant="light"
        header-text-variant="dark"
        hide-footer
      >
        <b-card>
          <b-row
            ><b-col
              >By clearing this item you will no longer be reminded of current
              status</b-col
            ></b-row
          >
          <b-row
            ><b-col
              >Risk Assessment will remain in Completed tab for viewing</b-col
            ></b-row
          >
          <b-button
            size="sm"
            variant="outline-info"
            v-on:click="RemoveRiskAssessment(ClearedID)"
            >Confirm</b-button
          >
        </b-card>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconDownload,
  BIconPlus,
  BIconCaretDownFill,
} from "bootstrap-vue/dist/bootstrap-vue.esm";
import PDF from "./PDFTemplate.vue";
import { riskDirectDownloadByKey } from "@/Services/aws.js";

export default {
  computed: {},
  components: {
    BIconDownload,
    BIconPlus,
    BIconCaretDownFill,
    PDF,
  },

  data() {
    return {
      CompletedRiskAssessments: [],
      CompletedRiskAssessmentsFields: [
        { key: "RAID", label: "Assessment ID", variant: "primary" },
        { key: "RAType", label: "Assessment Type" },
        { key: "RADesc", label: "Assessment Description" },
        { key: "RACompDate", label: "Completed Date" },
        { key: "RACompTime", label: "Completed Time" },
        { key: "RAAssessor", label: "Assessor" },
        { key: "Details", label: "Details" },
      ],
      ScheduledRiskAssessments: [],
      ScheduledRiskAssessmentsFields: [
        { key: "0", label: "Service ID", variant: "primary" },
        { key: "1", label: "Type" },
        { key: "2", label: "Category" },
        { key: "3", label: "Service Note" },
        { key: "4", label: "Room/Area" },
        { key: "5", label: "Location Note" },
        { key: "6", label: "Arranged by" },
        { key: "7", label: "Scheduled Date" },
        { key: "8", label: "Scheduled Time" },
        { key: "9", label: "Modify" },
      ],
      RiskAssessmentResults: [],
      RiskAssessmentFields: [
        { key: "RAID", label: "Assessment ID", variant: "primary" },
        { key: "RAType", label: "Assessment Type" },
        { key: "RADesc", label: "Assessment Description" },
        { key: "RADate", label: "Assessment Date" },
        { key: "RATime", label: "Assessment Time" },
        { key: "RAAssessor", label: "Assessor" },
        { key: "RADate", label: "Expiry Date" },
        { key: "RAStatus", label: "Status" },
        { key: "Details", label: "Details" },
      ],
      RiskFields: [
        { key: "0", label: "Category" },
        { key: "1", label: "Level" },
        { key: "2", label: "Note" },
      ],
      RiskActionFields: [
        { key: "0", label: "ID" },
        { key: "1", label: "Type" },
        { key: "3", label: "Due" },
        { key: "View", label: "" },
      ],
      RiskAssessItems: [],
      CompletedRiskAssessItems: [],
      ValidCounts: "",
      DueCounts: "",
      ExpiredCounts: " ",
      AssType: [
        { text: "Select Type", value: null, disabled: true },
        { text: "Full Room/Area", value: "Full Room" },
      ],

      outletAssessmentType: null,
      form: {
        name: "",
        Type: null,
        newRADate: null,
      },
      riskassessments: [
        { text: "Select Assessment Type", value: null, disabled: true },
        "Full Assessment",
      ],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      modal: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      name: localStorage.getItem("fullname"),
      statusColour: "",
      PassItem: [],
      ModifiedBooking: {
        ServiceID: null,
        Area: null,
        Description: null,
        Room: null,
        Type: null,
        ArrangedBy: null,
        Date: null,
        Time: null,
      },
      newBooking: {
        Type: null,
        CheckType: null,
        OutletID: null,
        Room: null,
        Note: null,
        Date: null,
        Email: null,
        Name: null,
      },
      selected: null,
      doPDF: false,
      componentKey: 0,
      modalShowing: null,
      RiskFindings: "",
      RiskRecommendations: "",
      RiskActions: [],
      RiskRisks: [],
      DormantID: "",
      ClearedID: "",
      RiskCategory: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrlCounts =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCounts = this.$apikeyPost;
    let LookUpRequestCounts = {
      ServiceType: "RiskAssessment",
      RequestType: "RiskAssessmentCounts",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpUrlCounts, LookUpRequestCounts, LookUpHeadersCounts)
      .then((response) => {
        this.DueCounts = response.data.Due;
        this.ExpiredCounts = response.data.Expired;
        this.ValidCounts = response.data.Review;
      });

    let LookUpURLStatus =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersStatus = this.$apikeyPost;
    let LookUpRequestStatus = {
      ServiceType: "RiskAssessment",
      RequestType: "RiskAssessmentStatus",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpURLStatus, LookUpRequestStatus, LookUpHeadersStatus)
      .then((response) => {
        this.RiskAssessmentResults = response.data.Values;
        for (let i = 0; i < this.RiskAssessmentResults.length; i++) {
          if (this.RiskAssessmentResults[i][9] == "Reviewed") {
            this.RiskAssessmentResults;
          } else {
            this.RiskAssessItems.push({
              RAID: this.RiskAssessmentResults[i][0],
              RAArea: this.RiskAssessmentResults[i][1],
              RARoom: this.RiskAssessmentResults[i][2],
              RAType: this.RiskAssessmentResults[i][3],
              RADesc: this.RiskAssessmentResults[i][4],
              RADate: this.RiskAssessmentResults[i][5],
              RATime: this.RiskAssessmentResults[i][6],
              RAAssessor: this.RiskAssessmentResults[i][7],
              RAExpiry: this.RiskAssessmentResults[i][8],
              RAStatus: this.RiskAssessmentResults[i][9],
            });
          }
        }
      });

    let LookUpURLScheduled =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersScheduled = this.$apikeyPost;
    let LookUpRequestScheduled = {
      ServiceType: "RiskAssessment",
      RequestType: "RiskAssessmentScheduled",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpURLScheduled, LookUpRequestScheduled, LookUpHeadersScheduled)
      .then((response) => {
        response;
        this.ScheduledRiskAssessments = response.data.Values;
      });

    let LookUpURLCompleted =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/wms";
    let LookUpHeadersCompleted = this.$apikeyPost;
    let LookUpRequestCompleted = {
      ServiceType: "RiskAssessment",
      RequestType: "RiskAssessmentCompleted",
      DataDict: [
        {
          Location: this.selectedlocation,
        },
      ],
    };
    axios
      .post(LookUpURLCompleted, LookUpRequestCompleted, LookUpHeadersCompleted)
      .then((response) => {
        this.CompletedRiskAssessments = response.data.Values;

        for (let i = 0; i < this.CompletedRiskAssessments.length; i++) {
          this.CompletedRiskAssessItems.push({
            RAID: this.CompletedRiskAssessments[i][0],
            RAType: this.CompletedRiskAssessments[i][1],
            RADesc: this.CompletedRiskAssessments[i][2],
            RADate: this.CompletedRiskAssessments[i][3],
            RACompDate: this.CompletedRiskAssessments[i][4],
            RACompTime: this.CompletedRiskAssessments[i][5],
            RAAssessor: this.CompletedRiskAssessments[i][6],
            RAStatus: "Completed",
          });
        }
      });
  },

  methods: {
    showRiskAssessmentNotes(item, category) {
      let DetailsLookupURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let DetailsLookupHeaders = this.$apikeyPost;
      let DetailsLookupRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentDetails",
        DataDict: [
          {
            AssessmentID: item.RAID,
          },
        ],
      };
      axios
        .post(DetailsLookupURL, DetailsLookupRequest, DetailsLookupHeaders)
        .then((response) => {
          this.RiskCategory = response.data.Values[5];
          this.RiskFindings = response.data.Values[12];
          this.RiskRecommendations = response.data.Values[13];
          this.RiskActions = response.data.Values[16];
          this.RiskRisks = response.data.Values[14];
        });

      this.PassItem = item;

      if (this.PassItem.RAStatus == "For Review") {
        this.statusColour = "info";
      } else if (this.PassItem.RAStatus == "Due") {
        this.statusColour = "warning";
      } else if (this.PassItem.RAStatus == "Expired") {
        this.statusColour = "danger";
      } else {
        this.statusColour = "secondary";
      }

      if (category == "current") {
        this.$refs["RiskAssessmentModal"].show(
          this.PassItem,
          this.statusColour
        );
      }
      if (category == "completed") {
        this.$refs["CompletedRiskAssessmentModal"].show(
          this.PassItem,
          this.statusColour
        );
      }
    },

    ShowNewBooking() {
      this.$refs["NewBookingModal"].show();
    },

    SubmitRABooking(passedID) {
      if (
        this.newBooking.Type == null ||
        this.newBooking.Room == null ||
        this.newBooking.Note == null ||
        this.newBooking.Name == null ||
        this.newBooking.CheckType == null ||
        this.newBooking.Date == null ||
        this.newBooking.Email == null
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EndID = "";
        EndID;
        if (this.newBooking.CheckType == "Single Outlet") {
          EndID = this.newBooking.OutletID;
        } else {
          EndID = "";
        }
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "New Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.newBooking.Name +
            "\\n" +
            this.newBooking.Email +
            "\\n\\n" +
            "Assessment Information " +
            "\\n\\n" +
            "Assessment Type - " +
            this.newBooking.CheckType +
            " " +
            this.newBooking.Type +
            "\\n" +
            "Room - " +
            this.newBooking.Room +
            "\\n" +
            "Location Note - " +
            this.newBooking.Note +
            "\\n" +
            "Date and Time - " +
            this.newBooking.Date +
            " at " +
            this.newBooking.Time,

          EmailSubject: "New Assessment Booking ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
            this.ResetRABooking();
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted, An Angel Guard staff member will be in touch."
        );

        if (passedID != "") {
          let RiskAssessmentUpdateURL =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/wms";
          let RiskAssessmentUpdateHeaders = this.$apikeyPost;
          let RiskAssessmentUpdateRequest = {
            ServiceType: "RiskAssessment",
            RequestType: "UpdateAssessmentStatus",
            DataDict: [
              {
                AssessmentID: passedID,
                Status: "Dormant",
              },
            ],
          };
          axios
            .post(
              RiskAssessmentUpdateURL,
              RiskAssessmentUpdateRequest,
              RiskAssessmentUpdateHeaders
            )
            .then((response) => {
              response;
              this.ResetRABooking();
            });
        } else {
          // console.log("no id");
        }

        this.$refs["RiskAssessmentModal"].hide();
      }
    },
    ResetRABooking() {
      this.newBooking = {};
      this.selected = null;
      this.CompletedRiskAssessItems = [];
      this.RiskAssessItems = [];
      let LookUpUrlCounts =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCounts = this.$apikeyPost;
      let LookUpRequestCounts = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentCounts",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpUrlCounts, LookUpRequestCounts, LookUpHeadersCounts)
        .then((response) => {
          this.DueCounts = "";
          this.ExpiredCounts = "";
          this.ValidCounts = "";
          this.DueCounts = response.data.Due;
          this.ExpiredCounts = response.data.Expired;
          this.ValidCounts = response.data.Review;
        });

      let LookUpURLStatus =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersStatus = this.$apikeyPost;
      let LookUpRequestStatus = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentStatus",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpURLStatus, LookUpRequestStatus, LookUpHeadersStatus)
        .then((response) => {
          this.RiskAssessmentResults = [];
          this.RiskAssessmentResults = response.data.Values;

          for (let i = 0; i < this.RiskAssessmentResults.length; i++) {
            if (this.RiskAssessmentResults[i][9] == "Reviewed") {
              this.RiskAssessmentResults;
            } else {
              this.RiskAssessItems.push({
                RAID: this.RiskAssessmentResults[i][0],
                RAArea: this.RiskAssessmentResults[i][1],
                RARoom: this.RiskAssessmentResults[i][2],
                RAType: this.RiskAssessmentResults[i][3],
                RADesc: this.RiskAssessmentResults[i][4],
                RADate: this.RiskAssessmentResults[i][5],
                RATime: this.RiskAssessmentResults[i][6],
                RAAssessor: this.RiskAssessmentResults[i][7],
                RAExpiry: this.RiskAssessmentResults[i][8],
                RAStatus: this.RiskAssessmentResults[i][9],
              });
            }
          }
        });

      let LookUpURLScheduled =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduled = this.$apikeyPost;
      let LookUpRequestScheduled = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentScheduled",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpURLScheduled,
          LookUpRequestScheduled,
          LookUpHeadersScheduled
        )
        .then((response) => {
          this.ScheduledRiskAssessments = [];
          this.ScheduledRiskAssessments = response.data.Values;
        });

      let LookUpURLCompleted =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersCompleted = this.$apikeyPost;
      let LookUpRequestCompleted = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentCompleted",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpURLCompleted,
          LookUpRequestCompleted,
          LookUpHeadersCompleted
        )
        .then((response) => {
          this.CompletedRiskAssessments = [];
          this.CompletedRiskAssessments = response.data.Values;

          for (let i = 0; i < this.CompletedRiskAssessments.length; i++) {
            this.CompletedRiskAssessItems.push({
              RAID: this.CompletedRiskAssessments[i][0],
              RAType: this.CompletedRiskAssessments[i][1],
              RADesc: this.CompletedRiskAssessments[i][2],
              RADate: this.CompletedRiskAssessments[i][3],
              RACompDate: this.CompletedRiskAssessments[i][4],
              RACompTime: this.CompletedRiskAssessments[i][5],
              RAAssessor: this.CompletedRiskAssessments[i][6],
              RAStatus: "Completed",
            });
          }
        });
      this.$refs["NewBookingModal"].hide();
    },

    modifyRiskAssessmentBooking(item) {
      let str = item[3];
      let index = str.indexOf(" ", str.indexOf(" ") + 1);
      let firstChunk = str.substr(0, index);
      let secondChunk = str.substr(index + 1);

      this.ModifiedBooking = {};
      this.ModifiedBooking = {
        ServiceID: item[0],
        Area: item[4],
        Description: item[3],
        Room: item[5],
        Type: secondChunk,
        CheckType: firstChunk,
        ArrangedBy: item[6],
        Date: item[7],
        Time: item[8],
      };

      this.$refs["ModifyRiskBookingModal"].show(this.ModifiedBooking);
    },
    SubmitModifiedBooking() {
      if (
        this.ModifiedBooking.Area == "" ||
        this.ModifiedBooking.Description == "" ||
        this.ModifiedBooking.Room == "" ||
        this.ModifiedBooking.Date == "" ||
        this.ModifiedBooking.Time == ""
      ) {
        alert("Please complete all fields to submit Booking request");
      } else {
        let EmailService = {
          ToEmail: "Support@seraphprotect.online",

          EmailText:
            "Modify Appointment Request raised by user.\\n\\n" +
            this.selectedlocation +
            "\\n" +
            this.name +
            "\\n\\n" +
            "Appointment Information " +
            "\\n\\n" +
            this.ModifiedBooking.ServiceID +
            "\\n" +
            "Type - " +
            this.ModifiedBooking.Description +
            "\\n " +
            this.ModifiedBooking.Type +
            "\\n" +
            "Room - " +
            this.ModifiedBooking.Room +
            "\\n" +
            "Area  - " +
            this.ModifiedBooking.Area +
            "\\n" +
            "New Date and Time - " +
            this.ModifiedBooking.Date +
            " at " +
            this.ModifiedBooking.Time,

          EmailSubject: "Service Request Booking Modification ",
        };

        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";

        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailService, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        alert(
          "Your Request has been submitted,An Angel Guard staff member will be in touch."
        );

        let ScheduledUpdateURL =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/service";
        let ScheduledUpdateHeaders = this.$apikeyPost;
        let ScheduledUpdateRequest = {
          RequestType: "UpdateService",
          RequestVariable: "",
          DataDict: [
            {
              ServiceID: this.ModifiedBooking.ServiceID,
              Status: "",
              UnderEdit: "TRUE",
            },
          ],
        };
        axios
          .post(
            ScheduledUpdateURL,
            ScheduledUpdateRequest,
            ScheduledUpdateHeaders
          )
          .then((response) => {
            response;
            this.ResetRABooking();
          });
        this.$refs["ModifyRiskBookingModal"].hide();
      }
    },
    CancelModifiedBooking() {
      this.ModifiedBooking = {};
      this.$refs["ModifyRiskBookingModal"].hide();
    },

    async DownloadAssessment(id, category) {
      let filekey = "";

      if (category == "Healthcare") {
        filekey =
          this.selectedlocation +
          "/Risk Assessments/" +
          id +
          "/" +
          "HealthcareRiskAssessment" +
          id +
          ".pdf";
      } else if (category == "NonHealthcare") {
        filekey =
          this.selectedlocation +
          "/Risk Assessments/" +
          id +
          "/" +
          "NonHealthcareRiskAssessment" +
          id +
          ".pdf";
      }

      let attachment = filekey;

      const res = await riskDirectDownloadByKey(attachment);

      axios({
        url: res, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filekey); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
    },

    MarkAsReviewed(id) {
      this.newBooking = {};

      let RiskAssessmentUpdateURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let RiskAssessmentUpdateHeaders = this.$apikeyPost;
      let RiskAssessmentUpdateRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "UpdateAssessmentStatus",
        DataDict: [
          {
            AssessmentID: id,
            Status: "Completed",
          },
        ],
      };
      axios
        .post(
          RiskAssessmentUpdateURL,
          RiskAssessmentUpdateRequest,
          RiskAssessmentUpdateHeaders
        )
        .then((response) => {
          response;
          this.ResetRABooking();
        });

      this.$refs["RiskAssessmentModal"].hide();
    },
    RequestRA(id) {
      this.DormantID = id;
      this.$refs["NewBookingModal"].show(this.DormantID);
    },
    ClearOverdue(id) {
      this.ClearedID = id;
      this.$refs["ClearRiskAssessmentModal"].show(this.ClearedID);
    },
    RemoveRiskAssessment(id) {
      let RiskAssessmentUpdateURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let RiskAssessmentUpdateHeaders = this.$apikeyPost;
      let RiskAssessmentUpdateRequest = {
        ServiceType: "RiskAssessment",
        RequestType: "UpdateAssessmentStatus",
        DataDict: [
          {
            AssessmentID: id,
            Status: "Dormant",
          },
        ],
      };
      axios
        .post(
          RiskAssessmentUpdateURL,
          RiskAssessmentUpdateRequest,
          RiskAssessmentUpdateHeaders
        )
        .then((response) => {
          response;
          this.TableRefresh();
        });

      this.$refs["ClearRiskAssessmentModal"].hide();
      this.$refs["RiskAssessmentModal"].hide();
    },
    TableRefresh() {
      let LookUpURLStatus =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersStatus = this.$apikeyPost;
      let LookUpRequestStatus = {
        ServiceType: "RiskAssessment",
        RequestType: "RiskAssessmentStatus",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(LookUpURLStatus, LookUpRequestStatus, LookUpHeadersStatus)
        .then((response) => {
          this.RiskAssessmentResults = [];
          this.RiskAssessItems = [];

          this.RiskAssessmentResults = response.data.Values;

          for (let i = 0; i < this.RiskAssessmentResults.length; i++) {
            this.RiskAssessItems.push({
              RAID: this.RiskAssessmentResults[i][0],
              RAArea: this.RiskAssessmentResults[i][1],
              RARoom: this.RiskAssessmentResults[i][2],
              RAType: this.RiskAssessmentResults[i][3],
              RADesc: this.RiskAssessmentResults[i][4],
              RADate: this.RiskAssessmentResults[i][5],
              RATime: this.RiskAssessmentResults[i][6],
              RAAssessor: this.RiskAssessmentResults[i][7],
              RAExpiry: this.RiskAssessmentResults[i][8],
              RAStatus: this.RiskAssessmentResults[i][9],
            });
          }
        });
    },
  },
  watch: {
    modalShowing() {
      this.doPDF = false;
    },
  },
};
</script>

<style>
#Table {
  margin: auto;
  text-align: center;
}

.headercol {
  border-bottom: solid 2px lightgrey;
  font-weight: bold;
  margin: 0;
  padding: 5px;
}
.bodycol {
  padding: 5px;
}
.actionrow {
  margin-left: auto;
  margin-right: auto;
}

#cancel-label {
  color: white;
  font-size: large;
}

.modal {
  text-align: center;
}
</style>
